// extracted by mini-css-extract-plugin
export default {"list":"list--IA5jg","bullet":"bullet--O9NFW","step":"step--5gbIo"};